import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CourseCard = ({ size, imageUrl, courseId }) => {
  const { t } = useTranslation();
  return (
    <Link to={`/course/${courseId}`}>
      <img button style={{ maxHeight: `${size}vh` }} src={t(imageUrl)} />
    </Link>
  );
};

export default CourseCard;
